export const siteContentDefaults = {
  footer: {
    description:
      "线上优选的CS:GO饰品获取平台，平台汇集大量稀有饰品，坐拥独家库存、极速发货，概率公开无暗箱，给用户带来安心可靠的游玩体验！",
    copyright: "© 2026 PIZZAKING. ALL RIGHTS RESERVED.",
  },
  about: {
    eyebrow: "关于 PIZZAKING",
    title: "关于 pizzaking",
    lead: "pizzaking 是围绕打开箱子、箱子战斗、升级、活动奖励和库存管理搭建的 CS 饰品娱乐平台。",
    sectionEyebrow: "我们是谁",
    sectionTitle: "为快速打开箱子体验而设计",
    points: [
      { title: "打开箱子体验", text: "箱子列表、掉落展示和打开箱子详情页统一使用 PizzaKing 深色视觉外壳。" },
      { title: "箱子战斗", text: "对战列表和房间页展示当前房间、箱子和参与状态，保持统一的对战视觉体验。" },
      { title: "库存管理", text: "中奖饰品通过现有系统库存管理，并通过已接入的发货流程处理饰品取回。" },
      { title: "账号系统", text: "PizzaKing 使用手机号、密码与验证码登录流程，不采用 Steam-only 登录。" },
    ],
    contactEyebrow: "支持",
    contactTitle: "联系我们",
    contactText: "如有账号、支付、发货或合作问题，请通过客服与平台运营方联系。",
  },
  agreement: {
    eyebrow: "用户协议",
    title: "用户协议",
    lead: "使用 pizzaking 前请阅读本协议。协议说明账号规则、平台使用、支付、饰品和服务限制等内容。",
    sourceLabel: "PizzaKing 版本 · 2026",
    sections: [
      { title: "用户行为", text: "你需要对账号下的内容、操作和活动负责，不得滥用服务、绕过平台规则、干扰系统、冒充他人或将本站用于违法行为。" },
      { title: "账号与安全", text: "pizzaking 使用手机号和密码账号体系。你需要妥善保管登录凭证，并对账号下执行的所有操作负责。" },
      { title: "饰品与钱包", text: "数字饰品和账号余额用于平台内体验，不属于现金、现金等价物，也不保证具备外部市场价值。" },
      { title: "服务可用性", text: "平台可能因维护、风控、安全或运营原因进行更新、暂停或调整。界面显示错误不代表用户有权获得特定结果。" },
      { title: "第三方服务", text: "部分支付、发货、机器人或平台接口可能依赖第三方服务，其可用性和处理规则可能影响账号操作。" },
      { title: "年龄与资格", text: "用户必须满足所在地适用的法定年龄和资格要求。如账号违反相关规则，平台可限制其访问。" },
    ],
  },
  privacy: {
    eyebrow: "隐私政策",
    title: "隐私政策",
    lead: "本页面说明 pizzaking 如何处理提供服务所需的账号、使用记录和安全相关信息。",
    sourceLabel: "PizzaKing 版本 · 2026",
    sections: [
      { title: "我们处理的信息", text: "我们可能处理手机号、账号名、登录状态、余额记录、玩法记录、库存数据、设备数据、Cookie 和平台运行所需的使用日志。" },
      { title: "信息用途", text: "这些信息用于账号访问、打开箱子、箱子战斗、升级、库存展示、充值记录、客服支持和平台安全。" },
      { title: "安全措施", text: "平台通过运营和技术措施降低未授权访问、账号滥用、支付风险和异常玩法行为。" },
      { title: "第三方处理", text: "当接入支付、发货或统计服务商时，相关信息可能仅为完成必要服务流程而由服务商处理。" },
      { title: "用户权利", text: "用户可就账号信息、更正请求、安全问题或政策疑问联系平台客服。" },
      { title: "政策更新", text: "当平台功能、服务商或法律要求发生变化时，本政策可能进行更新。" },
    ],
  },
  refund: {
    eyebrow: "退款与退回政策",
    title: "退款与退回政策",
    lead: "本页面说明退款政策、PizzaKing 钱包、数字饰品和取回服务相关事项。",
    sourceLabel: "PizzaKing 版本 · 2026",
    sections: [
      { title: "钱包余额", text: "充值到 pizzaking 钱包的额度是用于站内功能的平台余额，不属于现实货币，也不作为现金等价物处理。" },
      { title: "数字饰品结果", text: "打开箱子、箱子战斗或升级结果经后台确认后，将作为数字服务结果记录。" },
      { title: "未使用服务", text: "如果用户尚未使用付费服务，退款处理将取决于支付渠道、账号状态和平台审核结果。" },
      { title: "发货问题", text: "饰品发货及相关争议按照平台当前取回流程、第三方发货平台规则和审核结果处理。" },
      { title: "界面错误", text: "视觉异常、延迟刷新或界面显示错误不会改变后台已经确认的结果。" },
      { title: "异常活动", text: "存在异常支付、多账号、风控或滥用行为的账号，可能需要额外审核后才能继续钱包或发货操作。" },
    ],
  },
};

let contentRequest = null;

export function cloneSiteContent(key) {
  const source = key ? siteContentDefaults[key] : siteContentDefaults;
  return JSON.parse(JSON.stringify(source));
}

export function loadSiteContent(http) {
  if (!contentRequest) {
    contentRequest = http
      .post("/index/System/siteContent", "")
      .then((res) => (res.data.status == 1 ? res.data.data : cloneSiteContent()))
      .catch(() => cloneSiteContent());
  }
  return contentRequest;
}
